import {Switch as ArkSwitch} from '@ark-ui/react/switch'
import './index.less'

/**
 * @typedef {Object} SwitchRootProps
 * @property {import('react').ReactNode} children Ark switch parts rendered inside the root.
 * @property {boolean} [value] Controlled checked state.
 * @property {(value: boolean) => void} [onChange] Called with the next checked state.
 * @property {boolean} [disabled] Prevents interaction with the switch.
 * @property {boolean} [readOnly] Prevents value changes while retaining focus behavior.
 * @property {string} [className] Additional root classname.
 */

/** @param {SwitchRootProps} props */
export const SwitchRoot = ({children, value, onChange, disabled, readOnly, className}) => {
	const handleCheckedChange = details => onChange?.(details.checked)

	return (
		<ArkSwitch.Root
			checked={Boolean(value)}
			onCheckedChange={handleCheckedChange}
			disabled={disabled}
			readOnly={readOnly}
			className={className}
		>
			{children}
		</ArkSwitch.Root>
	)
}
